import { chakra, ImageProps, forwardRef } from "@chakra-ui/react";
import logoWhite from "./logo-black.png";
import logoBlack from "./logo-white.png";

export const ClientWhiteLogo = forwardRef<ImageProps, "img">((props, ref) => (
  <chakra.img src={logoWhite} ref={ref} {...props} />
));
export const ClientBlackLogo = forwardRef<ImageProps, "img">((props, ref) => (
  <chakra.img src={logoBlack} ref={ref} {...props} />
));
